/**
 * `localStorage` com rede de proteção: ausente em alguns contextos (Safari
 * privado, iframe de captura), lança em outros. Toda leitura e escrita passa
 * por aqui, e a ausência é tratada como "vazio", nunca como erro.
 */
import { domainConfig } from '../config';

function chave(nome: string): string {
  return `${domainConfig().storagePrefix}_${nome}`;
}

export const storage = {
  get(nome: string): string | null {
    try {
      return window.localStorage.getItem(chave(nome));
    } catch {
      return null;
    }
  },
  set(nome: string, valor: string): void {
    try {
      window.localStorage.setItem(chave(nome), valor);
    } catch {
      /* sem storage: sessão vive só em memória */
    }
  },
  remove(nome: string): void {
    try {
      window.localStorage.removeItem(chave(nome));
    } catch {
      /* idem */
    }
  },
  getJson<T>(nome: string): T | null {
    const cru = storage.get(nome);
    if (!cru) return null;
    try {
      return JSON.parse(cru) as T;
    } catch {
      return null;
    }
  },
  setJson(nome: string, valor: unknown): void {
    storage.set(nome, JSON.stringify(valor));
  },
};
